import React, {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';


import {useUserStatuses} from 'src/hooks/dictionaries';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {
    applyUpdatedData,
    setStatus,
} from 'src/modules/create-user/user-bulk-import/services/user-bulk-import.slice';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';

import type {UserStatus} from 'src/openapi/admin/models/UserStatus';

type Props = {
    selectedRecordIds: number[],
    availableStatusCodes: string[],
};

export const SetStatus = ({selectedRecordIds, availableStatusCodes}: Props) => {
    const dispatch = useDispatch();
    const {userFieldChange} = useEventTracking();

    const {userStatuses} = useUserStatuses();
    const availableStatuses = useMemo(
        () => userStatuses.filter(({code}) => availableStatusCodes.includes(code)),
        [userStatuses, availableStatusCodes],
    );

    const selectStatus = useCallback((userStatus: UserStatus) => {
        dispatch(applyUpdatedData());
        dispatch(setStatus({ids: selectedRecordIds, userStatus}));

        userFieldChange({
            section: 'Validate File',
            parameterName: 'Status',
            viewType: 'Bulk Import Users',
        });
    }, [selectedRecordIds, dispatch, userFieldChange]);

    return (
        <DropdownMenu anchor={({positionRef, getAnchorProps, anchorRef}) => (
            <FlatButton
                endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                {...getAnchorProps()}
                ref={anchorRef}>
                <b>Set Status</b>
            </FlatButton>
        )}>
            {availableStatuses.map(({code, description}) => (
                <DropdownMenuItem
                    key={code}
                    caption={description}
                    onClick={() => selectStatus(code as UserStatus)}
                />
            ))}
        </DropdownMenu>
    );
};
